import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbProps {
  currentPath: string;
  onNavigate: (path: string) => void;
}

export function Breadcrumb({ currentPath, onNavigate }: BreadcrumbProps) {
  if (!currentPath) return null;

  const pathParts = currentPath.split('/').filter(Boolean);
  const breadcrumbs = [
    { name: 'Home', path: '' },
    ...pathParts.map((part, index) => ({
      name: part,
      path: pathParts.slice(0, index + 1).join('/'),
    })),
  ];

  return (
    <nav className="flex items-center gap-0.5 overflow-x-auto scrollbar-none min-w-0">
      {breadcrumbs.map((crumb, index) => (
        <div key={crumb.path} className="flex items-center flex-shrink-0">
          {index > 0 && (
            <ChevronRight className="h-3.5 w-3.5 mx-0.5 text-gray-300 flex-shrink-0" />
          )}
          <button
            onClick={() => onNavigate(crumb.path)}
            className={`flex items-center gap-1 px-1.5 py-1 rounded-md text-sm transition-colors whitespace-nowrap ${
              index === breadcrumbs.length - 1
                ? 'text-gray-800 font-medium pointer-events-none'
                : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
            }`}
          >
            {index === 0 && <Home className="h-3.5 w-3.5 flex-shrink-0" />}
            {index > 0 && <span>{crumb.name}</span>}
          </button>
        </div>
      ))}
    </nav>
  );
}
